module.exports = __webpack_public_path__ + "img/SG.a4dee110.svg";